import { useBinDTOContext } from "src/queries/BinDTOContext";
import { BaseCsv } from "../modehistoryAndFanChangeHistory";
import { AddCsvOptions } from "./types";


export const useGrainTypeCsv = (options: AddCsvOptions) => {
    const grainTypeHeader = "Crop Type";
    const binDTO = useBinDTOContext()?.binDTO;
    const grainType = binDTO?.grain?.grainType;

    const newHeaders = [...options.headers, grainTypeHeader];
    const newData = options.data?.map(row => ({...row, [grainTypeHeader]: grainType}));
    return {data: newData, headers: newHeaders};
}